const actionsCache = {};

const internalActions = {
    FILTER_HEADER_LOADED: 'FILTER_HEADER_LOADED',
    loaded: (id) => ({
        type: 'FILTER_HEADER_LOADED',
        id
    })
};

// eslint-disable-next-line no-return-assign
export default (prefix) => {
    let actions = actionsCache[prefix];
    if (actions) {
        return actions;
    }
    actions = {
        OPEN_FILTER: `${prefix}/OPEN_FILTER`,
        OPEN_DEFAULT_FILTER: `${prefix}/OPEN_DEFAULT_FILTER`,
        SET_FILTERS: `${prefix}/SET_FILTERS`,
        SET_DEFAULT_FILTERS: `${prefix}/SET_DEFAULT_FILTERS`,
        RESET_FILTERS: `${prefix}/RESET_FILTERS`,
        REMOVE_FILTER: `${prefix}/REMOVE_FILTER`,
        REMOVE_DEFAULT_FILTER: `${prefix}/REMOVE_DEFAULT_FILTER`,
        UPDATE_FILTER: `${prefix}/UPDATE_FILTER`,
        UPDATE_DEFAULT_FILTER: `${prefix}/UPDATE_DEFAULT_FILTER`,
        ADD_FILTER: `${prefix}/ADD_FILTER`,
        ADD_DEFAULT_FILTER: `${prefix}/ADD_DEFAULT_FILTER`,
        SET_FILTER_DEFINITIONS: `${prefix}/SET_FILTER_DEFINITIONS`,
        FETCH_AVAILABLE_LIST_VALUES: `${prefix}/FETCH_AVAILABLE_LIST_VALUES`,
        SET_AVAILABLE_LIST_VALUES: `${prefix}/SET_AVAILABLE_LIST_VALUES`,
    };
    actions.openFilter = (filterId) => ({
        type: actions.OPEN_FILTER,
        filterId
    });
    actions.openDefaultFilter = (defaultFilterId) => ({
        type: actions.OPEN_DEFAULT_FILTER,
        defaultFilterId
    });
    actions.setFilters = (filters) => ({
        type: actions.SET_FILTERS,
        filters
    });
    actions.setDefaultFilters = (defaultFilters) => ({
        type: actions.SET_DEFAULT_FILTERS,
        defaultFilters
    });
    actions.resetFilters = () => ({
        type: actions.RESET_FILTERS
    });
    actions.removeFilter = (filterId) => ({
        type: actions.REMOVE_FILTER,
        filterId
    });
    actions.removeDefaultFilter = (defaultFilterId) => ({
        type: actions.REMOVE_DEFAULT_FILTER,
        defaultFilterId
    });
    actions.updateFilter = (filterId, value) => ({
        type: actions.UPDATE_FILTER,
        filterId,
        value
    });
    actions.updateDefaultFilter = (defaultFilterId, value) => ({
        type: actions.UPDATE_DEFAULT_FILTER,
        defaultFilterId,
        value
    });
    actions.addFilter = (filterId) => ({
        type: actions.ADD_FILTER,
        filterId
    });
    actions.addDefaultFilter = (defaultFilterId) => ({
        type: actions.ADD_DEFAULT_FILTER,
        defaultFilterId
    });
    actions.setFilterDefinitions = (filterDefinitions) => ({
        type: actions.SET_FILTER_DEFINITIONS,
        filterDefinitions
    });
    actions.fetchAvailableListValues = (filterId, availableListValuesLocation) => ({
        type: actions.FETCH_AVAILABLE_LIST_VALUES,
        filterId,
        availableListValuesLocation
    });
    actions.setAvailableListValues = (filterId, availableValues) => ({
        type: actions.SET_AVAILABLE_LIST_VALUES,
        filterId,
        availableValues
    });

    actionsCache[prefix] = actions;
    return actions;
};

export { internalActions };
